import type { FC, ReactNode } from 'react';

import Navigation from '../components/navigation';

interface LayoutProps {
  children: ReactNode;
}
const Layout: FC<LayoutProps> = ({ children }) => {
  return (
    <main className="min-h-screen">
      <div className="fade-in">
        <Navigation />
        {children}
      </div>
    </main>
  );
};
export default Layout;
